module.exports = __webpack_public_path__ + "static/media/tabs-battles-down.059d3a85.png";